/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import {Box, Typography} from "@mui/material";
import {SubmitHandler, UseFormReturn} from "react-hook-form";
import {Button} from "@mui/material";
import { PaymentFrequencyEnum } from "@/types/enums.ts";
import DropdownInput from "@/components/RHFcomponents/DropdownInput";
import {
    useGetCountriesAndStatesQuery,
    useGetDevicesQuery,
} from "@/redux-store/api/marketingApi";
import {getCountriesAndStatesOptions} from "@/utils/forms/getCountriesAndStatesOptions";
import {getDevicesOptions} from "@/utils/forms/getDevicesOptions";

interface IProps {
    methods: UseFormReturn<IPlanFilterFields, any, undefined>,
    onChangeFrequency?: (value: any) => void
}

const buttonData = [
    {
        label: 'Yearly',
        value: PaymentFrequencyEnum.YEARLY,
    },
    {
        label: 'Quarterly',
        value: PaymentFrequencyEnum.QUARTERLY,
    },
    {
        label: 'Monthly',
        value: PaymentFrequencyEnum.MONTHLY,
    },
];

const FilterForm: React.FC<IProps> = ({methods, onChangeFrequency}) => {
    const {data: devices} = useGetDevicesQuery({});
    const {data: countriesAndStates} = useGetCountriesAndStatesQuery({});
    const {countryOptions} = getCountriesAndStatesOptions(countriesAndStates);
    const devicesOptions = getDevicesOptions(devices);
    const {handleSubmit, control, reset} = methods;
    const onSubmit: SubmitHandler<IPlanFilterFields> = () => {
        reset();
    };
    const [currentButtonValue, setCurrentButtonValue] = useState<PaymentFrequencyEnum>(PaymentFrequencyEnum.YEARLY);
    const handleButtonClick = (value: PaymentFrequencyEnum) => {
        setCurrentButtonValue(value);
        if (onChangeFrequency) {
            onChangeFrequency(value);
        }
    };
    return (
        <Box
            component="div"
            onSubmit={handleSubmit(onSubmit)}
            gap={{xs: 2, md: 5}}
            display="flex"
            width={{xs: "100%"}}
            justifyContent="space-between"
            alignItems="flex-start"

            sx={{
                '@media screen and (max-width: 768px)': {
                    flexDirection:'column'
                },
            }}
        >
            {countryOptions.length > 0 &&
                devicesOptions &&
                devicesOptions.length > 0 && (
                    <div
                        className="dropdownBox"
                    >
                        <Box
                            component="label"
                            width="47%"
                            // minWidth="300px"
                            display="flex"
                            flexDirection={{xs: "column", md: "row"}}
                            alignItems={{xs: "start", md: "center"}}
                            gap={{xs: 1, md: 1.5}}
                            marginRight={"5%"}
                        >
                            <Typography
                                fontWeight={600}
                                whiteSpace="nowrap"
                                variant="body1"
                                component="span"
                            >
                                By Country:
                            </Typography>
                            <DropdownInput
                                name="countryId"
                                control={control}
                                options={countryOptions}
                                placeholder="All countries"
                            />
                        </Box>

                        <Box
                            component="label"
                            width="47%"
                            display="flex"
                            flexDirection={{xs: "column", md: "row"}}
                            alignItems={{xs: "start", md: "center"}}
                            gap={{xs: 1, md: 1.5}}
                        >
                            <Typography
                                fontWeight={600}
                                whiteSpace="nowrap"
                                variant="body1"
                                component="span"
                            >
                                By Device:
                            </Typography>
                            <DropdownInput
                                name="deviceId"
                                control={control}
                                options={devicesOptions}
                                placeholder="All devices"
                            />
                        </Box>
                    </div>
                )}

            <Box
                display="flex"
                flexDirection="column"
                alignItems="flex-end"

                sx={{
                    '@media screen and (max-width: 768px)': {
                        alignItems:'flex-start'
                    },
                }}
            >
                <Box
                    border="solid 1px #EAEFFC"
                    display="flex"
                    justifyContent="space-between"
                    sx={{
                        padding: '2px',
                        gap: '0px',
                        borderRadius: '1000px',
                        border: '1px solid rgba(228, 229, 233, 1)',
                    }}
                >
                    {buttonData.map((button) => (
                        <Button
                            key={button.value}
                            variant="contained"
                            sx={{
                                borderRadius: '1000px',
                                padding: '12px 30px',
                                fontFamily: 'Mulish',
                                color: currentButtonValue === button.value ? 'white' : 'rgba(51, 51, 51, 1)',
                                background: currentButtonValue === button.value ? '#FF6B00' : '#ffffff',
                                boxShadow: 'none',
                                border: 'none',
                                '&:hover': {
                                    background: currentButtonValue === button.value ? '#FF6B00' : 'rgba(255, 107, 0, 0.05)',
                                    color: currentButtonValue === button.value ? 'white' : 'rgba(51, 51, 51, 1)',
                                    boxShadow: 'none',
                                },
                                '&:active': {
                                    outline: 'none',
                                    border: 'none',
                                    background: '#FF6B00',
                                    color: 'white',
                                },
                                '&:focus': {
                                    outline: 'none',
                                },
                            }}
                            onClick={() => handleButtonClick(button.value)}
                        >
                            {button.label}
                        </Button>
                    ))}
                </Box>
            </Box>
        </Box>
    );
};

export default FilterForm;
